import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import LightTable from './../../../reusable/LightTable/VeryLightTable';

export default class LinkedAlertsFeedsTable extends Component {
    static propTypes = {
        listItems: PropTypes.array,
        totalCount: PropTypes.number
    }

    static defaultProps = {
        listItems: null,
        totalCount: 0
    }

    /**
     * Row formatter
     * @param item
     * @returns {{key, name, type: XML, object: *}}
     */
    formatItem = (item) => {
        return {
            key: item.name + item.type,
            name: item.name,
            type: <FormattedMessage id={"General_CoreFunctionality_UIText_general." + item.type}/>,
            object: item
        }
    };

    headerItems = [
        {
            key: "name",
            label: "Title",
            sortable: true
        },
        {
            key: "type",
            label: "Type"
        }
    ]

    render = () => <LightTable { ...this.props }
                               headerItems={this.headerItems}
                               listItems={this.props.listItems ? this.props.listItems.map(item => this.formatItem(item)) : null}
                               totalCount={this.props.totalCount} />
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/LinkedAlertsFeedsTable.jsx